module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms15e-detail3Desc3"
    }
  }, [(_vm.detail.rows.length > 0) ? [(parseInt(_vm.detail.rows[_vm.detailIndex].total) > 0) ? [_c('div', {
    staticClass: "main-topic-box"
  }, [_c('i', {
    staticClass: "left-arrow fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.triggerSetDetailTab3Desc3Selected(-1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRAP31EC10']['40']) + " " + _vm._s(_vm.detailTab3Desc3Selected.kpino))]), _vm._v(" "), _c('i', {
    staticClass: "right-arrow fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.triggerSetDetailTab3Desc3Selected(1)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-header"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.labels['HRAP31EC10']['140']))])])]), _vm._v(" "), (!_vm.isEmpty(_vm.detail.rows[_vm.detailIndex].tableDesc3)) ? [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-block"
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.detail3Desc3Table,
      "data": {
        total: _vm.detail.rows[_vm.detailIndex].tableDesc3.length,
        rows: _vm.detail.rows[_vm.detailIndex].tableDesc3
      },
      "indexDisp": false,
      "searchDisp": false
    }
  })], 1)])] : [_c('div', {
    staticClass: "evaluation-sum "
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "col-md-12 control-label align-c"
  }, [_vm._v(_vm._s(_vm.labelsHrms15e['C70']) + " " + _vm._s(_vm.labels['HRAP31EC10']['140']))])])])]] : [_c('div', {
    staticClass: "evaluation-sum "
  }, [_c('div', {
    staticClass: "form-group "
  }, [_c('label', {
    staticClass: "col-md-12 control-label align-c"
  }, [_vm._v(_vm._s(_vm.labelsHrms15e['C70']) + " " + _vm._s(_vm.labels['HRAP31EC10']['140']))])])])]] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52afbe55!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/detail3Desc3.vue
// module id = 3757
// module chunks = 1